import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getImagingUltrasoundSelector } from '../selectors'
import { saveImagingUltrasound } from '../store/ImagingUltrasound.actions'
import { ImagingUltrasoundConstants } from '../store/imagingUltrasound.constants'
import { IImagingUltrasoundState } from '../store/ImagingUltrasound.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const imagingUltrasoundState: IImagingUltrasoundState = yield select(getImagingUltrasoundSelector)
  const { comments } = imagingUltrasoundState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.imagingUltrasoundStateList && pcrDoc.patient?.imagingUltrasoundStateList.length) {
        const index = pcrDoc.patient?.imagingUltrasoundStateList?.findIndex(
          (imgUltrasound) => imgUltrasound.key === imagingUltrasoundState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.imagingUltrasoundStateList[index].comments !== comments) {
            yield put(saveImagingUltrasound())
          }
        }
      } else {
        yield put(saveImagingUltrasound())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([ImagingUltrasoundConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
